export default __webpack_public_path__ + "static/media/apartment.a312e5f0.svg";